export const orange20 = "#FFAA2B";
export const orange15 = "#FFBB55";
export const orange10 = "#FFD495";
export const orange05 = "#FFEED4";

export const blue10 = "#f3f6ff";
export const blue20 = "#c4d0ff";

export const gray20 = "#696969";
export const gray18 = "#B9B9B9";
export const gray14 = "#DBDBDB";
